<template>

</template>

<script lang='ts'>
import { createComponent, onMounted, ref, onBeforeUnmount } from '@vue/composition-api'
import { isLt500 } from '../../utils'

export default createComponent({
    setup(props, ctx) {
        const closeFn = ref<() => void>(() => {})

        function downloadNavigationStarter() {
            import(/* webpackChunkName: "download_navigation" */ '@/components/download_navigation/download_navigation.tsx')
                .then(({ openDownloadNavigation }) => {
                    closeFn.value = openDownloadNavigation() as () => void
                })
        }

        function mobileDownloadNavigationStarter() {
            import(/* webpackChunkName: "mobile_download_navigation" */ '@/components/mobile_download_navigation/mobile_download_navigation.tsx')
                .then(({ openMobileDownloadNavigation }) => {
                    closeFn.value = openMobileDownloadNavigation() as () => void
                })
        }

        onMounted(() => {
            if (isLt500()) {
                mobileDownloadNavigationStarter()
            } else {
                downloadNavigationStarter()
            }
        })

        onBeforeUnmount(() => {
            closeFn.value()
        })
    }
})
</script>
